import React from 'react';

interface LayoutIconProps {
    color?: string;
}

export const DefaultLayoutIcon: React.FC<LayoutIconProps> = ({ color = 'var(--color-gray-900)' }) => (
    <svg viewBox="0 0 24 24" className="w-full h-full" preserveAspectRatio="xMidYMid meet">
        <rect x="2" y="6" width="20" height="12" stroke={color} fill="none" strokeWidth="1.5"/>
    </svg>
);

export const TwoSplitLayoutIcon: React.FC<LayoutIconProps> = ({ color = 'var(--color-gray-900)' }) => (
    <svg viewBox="0 0 24 24" className="w-full h-full" preserveAspectRatio="xMidYMid meet">
        <rect x="2" y="6" width="20" height="12" stroke={color} fill="none" strokeWidth="1.5"/>
        <line x1="12" y1="6" x2="12" y2="18" stroke={color} strokeWidth="1.5"/>
    </svg>
);

export const ScreenshareLayoutIcon: React.FC<LayoutIconProps> = ({ color = 'var(--color-gray-900)' }) => (
    <svg viewBox="0 0 24 24" className="w-full h-full" preserveAspectRatio="xMidYMid meet">
        <rect x="2" y="6" width="20" height="12" stroke={color} fill="none" strokeWidth="1.5"/>
        <path d="M2 6 L8 6 L8 11 L2 11" stroke={color} strokeWidth="1.5" fill="none"/>
    </svg>
);

export const GameplayLayoutIcon: React.FC<LayoutIconProps> = ({ color = 'var(--color-gray-900)' }) => (
    <svg viewBox="0 0 24 24" className="w-full h-full" preserveAspectRatio="xMidYMid meet">
        <rect x="2" y="6" width="20" height="12" stroke={color} fill="none" strokeWidth="1.5"/>
        <line x1="17" y1="6" x2="17" y2="18" stroke={color} strokeWidth="1.5"/>
    </svg>
);

export const ThreeSpeakersLayoutIcon: React.FC<LayoutIconProps> = ({ color = 'var(--color-gray-900)' }) => (
    <svg viewBox="0 0 24 24" className="w-full h-full" preserveAspectRatio="xMidYMid meet">
        <rect x="2" y="6" width="20" height="12" stroke={color} fill="none" strokeWidth="1.5"/>
        <line x1="8" y1="6" x2="8" y2="18" stroke={color} strokeWidth="1.5"/>
        <line x1="16" y1="6" x2="16" y2="18" stroke={color} strokeWidth="1.5"/>
    </svg>
);

export const FourSpeakersLayoutIcon: React.FC<LayoutIconProps> = ({ color = 'var(--color-gray-900)' }) => (
    <svg viewBox="0 0 24 24" className="w-full h-full" preserveAspectRatio="xMidYMid meet">
        <rect x="2" y="4" width="20" height="16" stroke={color} fill="none" strokeWidth="1.5"/>
        <line x1="12" y1="4" x2="12" y2="20" stroke={color} strokeWidth="1.5"/>
        <line x1="2" y1="12" x2="22" y2="12" stroke={color} strokeWidth="1.5"/>
    </svg>
);

export const SquareLayoutIcon: React.FC<LayoutIconProps> = ({ color = 'var(--color-gray-900)' }) => (
    <svg viewBox="0 0 24 24" className="w-full h-full" preserveAspectRatio="xMidYMid meet">
        <rect x="2" y="2" width="20" height="20" stroke={color} fill="none" strokeWidth="1.5"/>
    </svg>
);

export const PortraitLayoutIcon: React.FC<LayoutIconProps> = ({ color = 'var(--color-gray-900)' }) => (
    <svg viewBox="0 0 24 24" className="w-full h-full" preserveAspectRatio="xMidYMid meet">
        <rect x="6" y="2" width="12" height="20" stroke={color} fill="none" strokeWidth="1.5"/>
    </svg>
);

export const LandscapeLayoutIcon: React.FC<LayoutIconProps> = ({ color = 'var(--color-gray-900)' }) => (
    <svg viewBox="0 0 24 24" className="w-full h-full" preserveAspectRatio="xMidYMid meet">
        <rect x="2" y="6" width="20" height="12" stroke={color} fill="none" strokeWidth="1.5"/>
    </svg>
); 